import { LogOut, UserCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DensityToggle } from "@/components/DensityToggle";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useMe } from "@/hooks/use-me";
import { authApi } from "@/api/auth";
import { queryKeys } from "@/lib/query-keys";

export function Header() {

    const me = useMe();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const logout = useMutation({
        mutationFn: () => authApi.logout(),
        onSuccess: () => {

            queryClient.removeQueries({ queryKey: queryKeys.auth.me() });
            navigate("/login", { replace: true });
        },
    });

    return (
        <header className="h-[var(--header-h)] border-b bg-background flex items-center justify-between px-4">
            <div className="text-sm text-muted-foreground" />
            <div className="flex items-center gap-2">
                <DensityToggle />
                <ThemeToggle />
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" aria-label="User menu">
                            <UserCircle />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-56">
                        <DropdownMenuLabel className="font-normal text-xs text-muted-foreground">
                            {me.data?.user?.email ?? "—"}
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={() => logout.mutate()} disabled={logout.isPending}>
                            <LogOut className="mr-2 size-4" />
                            Log out
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </header>
    );
}
